export default __webpack_public_path__ + "static/media/header_menu.732c05c3.png";